var map = {
	"./part_1.png": "S4lU",
	"./part_2.png": "3YWB",
	"./part_3.png": "MoF4",
	"./part_4.png": "OiLq",
	"./part_5.png": "IH3e",
	"./part_6.png": "slAE",
	"./part_7.png": "6AXN",
	"./part_8.png": "C4r2",
	"./part_9.png": "T73g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xKUi";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/part_.*\.png$
// module id = xKUi
// module chunks = 0